import isEqual from 'lodash/isEqual';
import { SelectedItemInterface } from 'modules/ui/lists/MapList/list/types';

export const isSelectedOption = (value: SelectedItemInterface, selectedOptions: SelectedItemInterface[]) =>
  !!selectedOptions.find((selectedOption) => isEqual(value, selectedOption));

export const isOpenGroup = (value: string, openedGroups: string[]) => openedGroups.includes(value);
